/**
 * Clear All Quote/Cart Stores
 *
 * Resets all cart-related Legend-State stores to their initial state.
 * This clears both IndexedDB-persisted data and in-memory observables.
 *
 * Used when the server returns cart permission errors like:
 * "The current user cannot perform operations on cart"
 *
 * This function is safe to call outside React (e.g., from Apollo errorLink callbacks).
 */

import { cartStoreAPI } from './cart-store.public-api';
import { cartItemReferenceStoreAPI } from './cart-item-reference-store.public-api';

import { checkoutCartStore$ } from './checkout-cart.store';
import { cartItemReferenceSynchronizationStore$ } from './cart-item-reference-synchronization.store';
import { cartItemReferenceSelectedToProcessLogicsStore$ } from './cart-item-reference-selected-to-process-logics.store';

/**
 * Clear all quote/cart module stores to fresh initial state.
 *
 * Clears the following IndexedDB tables:
 * - cart
 * - cartItemReference
 * - cartItemReferenceSynchronization
 * - cartItemReferenceSelectedLogics
 * - checkoutCart
 *
 * Does NOT clear: customer, checkout (separate module), giftSelection (separate module)
 */
export function clearAllQuoteStores(): void {
    console.log('[QuoteStores] Clearing all cart-related stores...');

    try {
        cartStoreAPI.actions.resetCart();
        cartItemReferenceStoreAPI.actions.resetStore();

        // Stores without public API — set each property individually
        // so Legend-State detects changes and syncs to IndexedDB properly.
        checkoutCartStore$.id.set('');
        checkoutCartStore$.items.set([]);

        cartItemReferenceSynchronizationStore$.syncStatus.set('idle');
        cartItemReferenceSynchronizationStore$.syncVersion.set(0);

        cartItemReferenceSelectedToProcessLogicsStore$.usageData.set(undefined);
        cartItemReferenceSelectedToProcessLogicsStore$.currentData.set(undefined);

        console.log('[QuoteStores] All cart-related stores cleared successfully');
    } catch (error) {
        console.error('[QuoteStores] Error clearing cart stores:', error);
    }
}
